export const palette = [
  'rgba(112, 48, 160, 1)',
  'rgba(144, 96, 180, 1)',
  'rgba(176, 144, 200, 1)',
  'rgba(195, 155, 225, 1)',
  'rgba(206, 176, 229, 1)',
  'rgba(218, 198, 233, 1)',
  'rgba(0, 32, 96, 1)',
  'rgba(60, 84, 132, 1)',
  'rgba(120, 136, 168, 1)',
  'rgba(26, 90, 148, 1)',
  'rgba(108, 151, 208, 1)',
  'rgba(158, 212, 248, 1)',
  'rgba(179, 219, 246, 1)',
  'rgba(199, 226, 244, 1)',
  'rgba(220, 233, 242, 1)',
  'rgba(33, 124, 135, 1)',
  'rgba(114, 171, 179, 1)',
  'rgba(196, 218, 222, 1)',
  'rgba(157, 165, 177, 1)',
  'rgba(196, 201, 208, 1)',
  'rgba(136, 73, 143, 1)',
  'rgba(119, 159, 154, 1)',
  'rgba(0, 83, 105, 1)',
  'rgba(71, 67, 80, 1)',
];
